/*
 * @Author: SK-20251129GXNS\Administrator zpx
 * @Date: 2026-01-20 22:07:02
 * @LastEditors: SK-20251129GXNS\Administrator zpx
 * @LastEditTime: 2026-01-21 16:35:54
 * @FilePath: \frontend\src\api\activity\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/request'
// 活动列表列表Api
export function activityListApi() {
  return request.get('/activity/list')
}
// 救援基金列表
export function ActivityConfigApi(data) {
  return request.post('/activityConfig/dailyLoss', data)
}
// 救援基金领取操作
export function dailyLossDrawApi(data) {
  return request.post('/activityConfig/dailyLossDraw', data)
}
// 救援基金领取历史
export function dailyLossDrawHistoryApi(data) {
  return request.post('/activityConfig/dailyLossDrawHistory', data)
}
// 奖励头部信息
export function firstChargeInfoApi() {
  return request.get('/activity/firstCharge/info')
}
// 首充奖励
export function firstChargeApi() {
  return request.post('/activity/firstCharge/claim')
}
// 邀请宝箱
// 邀请个人信息
export function inviteBoxApi() {
  return request.get('/activity/invite/userinfo')
}
// 邀请宝箱列表
export function boxListApi() {
  return request.get('/inviteBonus/getTreasureInfo')
}
// 邀请宝箱领取操作
export function inviteBoxClaimApi(data) {
  return request.post('/inviteBonus/claim', data)
}

export function mychildApi(data) {
  return request.post('/activity/invite/mychild', data)
}
// 获取邀请奖金页面展示模式
export function getModeApi() {
  return request.get('/inviteBonus/getMode')
}
// 规则信息
export function loginBonusApi() {
  return request.get('/activityConfig/loginBonusExplain')
}
// 每日登录奖励领取
export function claimJoinLoginApi() {
  return request.get('/activity/joinLoginBonus')
}
// 悬浮图登录后
export function floatingImgLoginApi() {
  return request.get('/activity/floatingImgLogin')
}
// // 获取存款奖金信息
export function getDepositBonusApi() {
  return request.get('/inviteBonus/getDepositBonusInfo')
}
// // 邀请奖励首页
export function inviteBonusApi() {
  return request.get('/inviteBonus/index')
}
// // 获取首存页面信息
export function getInfoFirstChargeInfoApi() {
  return request.get('/inviteBonus/getBonusInfoFirstCharge')
}
// // 获取存款页面信息
export function getInfoRechargeInfoApi() {
  return request.get('/inviteBonus/getBonusInfoRecharge')
}
// 日投注返利游戏列表
export function getRebateGameListApi(data) {
  return request.post('/dailyBet/gameList', data)
}
// 领取日投注返利
export function getRebateApi(data) {
  return request.post('/dailyBet/claim', data)
}
// 领取日投注返利个人信息
export function getRebateInfoApi() {
  return request.get('/dailyBet/info')
}
// 日投注返利详情
export function gettierDetailApi(data) {
  return request.post('/dailyBet/tierDetail', data)
}
// 等级配置
export function getlevelConfigApi() {
  return request.get('/agent/levelConfig')
}

// 获取存钱罐信息
export function moneyBoxGetInfoApi() {
  return request.get('/moneyBox/getInfo')
}
// 操作日志列表
export function moneyBoxLogListApi(data) {
  return request.post('/moneyBox/logList', data)
}
// 存入
export function moneyBoxDepositApi(data) {
  return request.post('/moneyBox/deposit', data)
}
// 取出
export function moneyBoxWithdrawApi(data) {
  return request.post('/moneyBox/withdraw', data)
}
// 领取利息
export function moneyBoxClaimInterestApi(data) {
  return request.post('/moneyBox/claimInterest', data)
}

// 查询兑换码状态
export function redeemCodeCheckStatusApi(data) {
  return request.get('/redeemCode/checkStatus', { params: data })
}

// 领取奖励
export function redeemCodeClaimApi(data) {
  return request.post('/redeemCode/claim', data)
}

// 首页悬浮图
export function getFloatingImgApi(paramsData) {
  return request.get('/activity/floatingImg', { params: paramsData })
}
